module.exports = __webpack_public_path__ + "images/img_nego_6b087fb090cf8bf7e99b92337c5ca24e.png";